module.exports = __webpack_public_path__ + "img/seedpaper-irish-jig.c6f69522.png";